import { createAction } from 'redux-actions';

import { getPackageInfo } from '../api/packageInfo';
import { REQUEST_PACKAGE_INFO_SUCCESS, REQUEST_PACKAGE_INFO_FAILURE } from '../constants/actionTypes';
import { showErrorSnackbar } from './snackbar';
const requestPackageInfoSuccess = createAction('REQUEST_PACKAGE_INFO_SUCCESS');
const requestPackageInfoFailure = createAction('REQUEST_PACKAGE_INFO_FAILURE');

// eslint-disable-next-line import/prefer-default-export
export function requestPackage() {
  return dispatch => getPackageInfo()
    .then(({ data }) => dispatch(requestPackageInfoSuccess(data)))
    .catch(error => {
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
      dispatch(requestPackageInfoFailure(error?.response?.data?.errors?.error))}});
}
